// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';

function handleReportNumberChange(event) {

    this('reportNumber', event.target.value);

}

const ReportNumber = ({onItemChange, statusChangeRequest}) => {

    const status = statusChangeRequest.newStatus.key;

    return (
        <div className='labeled-string'>
            <span className='data-label'>
                <sup>{status === 'STL1' || status === 'STLP' ? '*' : null}</sup> <FormattedMessage id='REPORT_NUMBER'/>
            </span>
            <input
                maxLength='19'
                onChange={onItemChange::handleReportNumberChange}
                type='text'
            />
        </div>
    );

};

ReportNumber.displayName = 'ReportNumber';
ReportNumber.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired
};

export default ReportNumber;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/input-fields/report-number.js